import {
    GET_DATA_FAIL,
    GET_DATA_SUCCESS,
    GET_DATA_START,
    GET_QUARTER_DATA_START,
    GET_QUARTER_DATA_SUCCESS,
    GET_QUARTER_CHART_START,
    GET_QUARTER_CHART_SUCCESS,
    GET_QUARTER_DSP_CHART_START,
    GET_QUARTER_DSP_CHART_SUCCESS,
    GET_QUARTER_TERRITORY_CHART_START,
    GET_QUARTER_TERRITORY_CHART_SUCCESS,
    GET_ASSET_PROFILE_START,
    GET_ASSET_PROFILE_SUCCESS,
    GET_TOPS_QUARTER_START,
    GET_TOPS_QUARTER_SUCCESS,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_START,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_SUCESS,
    GET_QUARTER_TERRITORY_CHART_STREAMS_START,
    GET_QUARTER_TERRITORY_CHART_STREAMS_SUCESS,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_START,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_SUCESS,
    GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_START,
    GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_SUCESS,
    GET_ISRC_DSP_CHART_START,
    GET_ISRC_DSP_CHART_SUCESS,

    GET_ISRC_CHART_DATE_START,
    GET_ISRC_CHART_DATE_SUCESS,
    GET_QUARTER_ACTIVITY_CHART_START,
    GET_QUARTER_ACTIVITY_CHART_SUCCESS,
    GET_IMPERSONATION_LIST_START,
    GET_IMPERSONATION_LIST_SUCCESS,
    SET_IMPERSONATION_LIST_START,
    SET_IMPERSONATION_LIST_SUCCESS,
    SET_AUDIOURL,
    SORT_TEMP_SHORTLIST,
    SELECT_TRACK,
    SET_SHORTLIST_NAME,
    REQUEST_CREATE_SHORTLIST,
    RECEIVE_CREATE_SHORTLIST,
    SET_SHORTLIST,
    REQUEST_SHORTLIST_DRAFT,
    RECEIVE_SHORTLIST_DRAFT,
    REQUEST_AUTOCOMPLETE_SHORTLIST,
    RECEIVE_AUTOCOMPLETE_SHORTLIST,
    RECEIVE_SHORTLIST_ANALYSIS,
    REQUEST_SHORTLIST_ANALYSIS,
    MODIFY_SHORTLIST,
    SET_TAB,
    SET_SHORTLIST_ISRC,
    SET_CATALOG_FILTER,

    SET_CATALOG_SELECTED,
    SET_GENRES_SELECTED,
    RECEIVE_READY_SHORTLIST,
    RECEIVE_DELETE_SHORTLIST,
    CLEAR_SHORTLIST,
    GET_UPC_DATA,
    UPC_DATA_SUCCESS,
    GET_RELEASE_DATA,
    RELEASE_DATA_SUCCESS,
    REQUEST_NAME_SHORTLIST,
    RECEIVE_NAME_SHORTLIST,
    SET_SHORTLIST_BY_STATE,
    RECEIVE_SHORTLIST_ANALYSIS_INTERNAL,
    SET_UPCS_TERRITORIES,
    REQUEST_TERRITORY_CHANGE,
    REQUEST_TERRITORY_CHANGE_SUCCESS,
    REQUEST_ASSET_TAGS_LIST,
    RECEIVE_ASSET_TAGS_LIST,
    REQUEST_AUTOCOMPLETE_TAGS,
    RECEIVE_AUTOCOMPLETE_TAGS,
    REQUEST_SAVE_TAGS,
    RECEIVE_SAVE_TAGS,
    SET_MOODS,
    REQUEST_PUBLISH_PRODUCT,
    REQUEST_PUBLISH_PRODUCT_SUCCESS,
    SET_UPCS_PUBLISH,
    REQUEST_CATALOG_CHANGE,
    REQUEST_CATALOG_CHANGE_SUCCESS,
    SET_CATALOG_CODES,
    REQUEST_MASS_PRODUCT_CHANGE,
    REQUEST_MASS_PRODUCT_SUCCESS,
    SET_MASS_PRODUCT_CODES,
    SELECT_PRODUCT_FOR_UPDATE,
    REQUEST_SINGLE_PRODUCT_CHANGE,
    REQUEST_SINGLE_PRODUCT_CHANGE_SUCCESS,
    REQUEST_GENRE_SHORTLIST,
    RECEIVE_GENRE_SHORTLIST,
    REQUEST_SUBGENRE_SHORTLIST,
    RECEIVE_SUBGENRE_SHORTLIST,
    SET_UPCS_UPDATE,
    REQUEST_UPDATE_PRODUCT,
    REQUEST_UPDATE_PRODUCT_SUCCESS,
    REQUEST_UPDATE_ASSET,
    REQUEST_UPDATE_ASSET_SUCCESS,
    SET_ISRCS_UPDATE,
    REQUEST_UPDATE_LOP,
    REQUEST_UPDATE_LOP_SUCCESS,
    SET_UPCS_LOP_UPDATE,
    GET_SYNC_DATA_SUCCESS,
    GET_SYNC_DATA,
    SELECT_SYNC_TRACK,
    SET_TAB_SYNC,
    REQUEST_UPDATE_LYRICIST,
    REQUEST_UPDATE_LYRICIST_SUCCESS,
    SET_UPCS_LYRICIST_UPDATE,
    SET_FILTER_TITLE,
    SET_FILTER_GENRE,
    SET_FILTER_ISRC,
    GET_ML_TAGS,
    GET_ML_TAGS_SUCCESS,
    SET_TAG_ML_SHOW,
    SET_TAG_ML_SHOW_SUCCESS,
    SET_TAG_ML_VERIFIED,
    SET_TAG_ML_VERIFIED_SUCCESS,
    SET_ML_ASSET_SELECTED,
} from '../Types';
import { bool } from 'prop-types';


const INITIAL_STATE = {
    register_error: '',
    user: null,
    isLogin: null,
    login_error: '',
    summary: null,
    quarterList: null,
    selectedQuarter: "",
    quarterChart: null,
    dspQuarter: "",
    dspQuarterChart: null,
    territoryQuarter: "",
    territoryQuarterChart: null,
    requestedISRC: "",
    assetData: null,
    isLoadingAsset: true,
    topsQuarter: "",
    topsQuarterData: null,
    territoryStreams: null,
    territoryStreamsQuarter: "",
    territoryDownloads: null,
    territoryDownloadsQuarter: "",
    territoryDownloadsIsrc: "",
    territoryStreamsIsrc: "",
    territoryDownloadsIsrcData: null,
    territoryStreamsIsrcData: null,
    dspISRC: "",
    dspISRCData: null,
    chartIsrc: "",
    chartIsrcType: "",
    chartIsrcStartMonth: null,
    chartIsrcStartYear: null,
    chartIsrcEndYear: null,
    chartIsrcEndMonth: null,
    chartIsrcActivity: null,
    activityQuarter: "",
    activityChart: null,
    recipientList: null,
    recipientListLoading: false,
    recipientID: "",
    recipientSaving: false,
    audioURL: "",
    shortlistDetail: null,
    tempShortList: [],
    shortListName: "",
    isSavingAssetsToShortList: false,
    requestedShortList: "",
    requestedShortListReady: "",
    shortLists: [],
    isLoadingShortListAnalysis: false,
    shortlistAnalysis: null,
    shortlistAnalysisReady: null,
    selectedShortlist: null,
    selectedShortlistReady: null,
    selectedShortlistCorrection: null,
    forceUpdate: false,
    tabIndex: 0,
    shortListISRC: "",
    filtered: [],
    select2: undefined,
    catalogues: [],
    genres: [],
    genresSelect: undefined,
    shortListsReady: [],
    shortlistDetailReady: null,
    selectedUPCS: "",
    upcData: null,
    isLoadingUPCList: false,
    isLoadingReleaseList: false,
    releaseData: null,
    selectedReleaseUPCS: "",
    shortListsCorrections: [],
    territoriesUPCS: [],
    requestedTerritoryUPC: "",
    isSavingTerritory: false,
    requestedTerritoryType: "",
    territoryResults: [],
    isLoadingAssetTagsList: false,
    assetTagsList: [],
    currentPage_Tags: -1,
    maxRecords_Tags: 0,
    maxPage_Tags: 0,
    isSavingTags: false,
    moods: [],
    environmental: [],
    audio_quality: [],
    audio_tags: [],
    instruments: [],
    isLoadingAudioTags: false,
    isLoadingMoods: false,
    isLoadingInstruments: false,
    isloadingQuality: false,
    isLoadingEnvironmental: false,
    selectedMoods: [],
    selectedEnvironmental: [],
    selectedaudio_quality: [],
    selectedinstruments: [],
    selectedaudio_tags: [],
    isPublishingProduct: false,
    requestedPublishUPC: "",
    publishUPCS: [],
    publishResults: [],
    requestedCatalogCode: "",
    isSavingCatalog: false,
    catalogCodes: [],
    catalogResults: [],
    requestedCatalog: "",
    requestedMassProductCode: "",
    isSavingMassProductChange: false,
    massProductChangeCodes: [],
    massProductChangeResults: [],
    requestedMassProductChangeProperty: "",
    requestedMassProductChangeValue: "",
    selectedProductForUpdate: "",
    isLoadingShortlists: false,
    isLoadingReadyShortLists: false,
    firstLoad: false,
    isUpdatingProduct: false,
    requestedUpdateUPC: "",
    updateUPCS: [],
    updateResults: [],
    isUpdatingAsset: false,
    requestedUpdateISRC: "",
    updateISRCS: [],
    updateISRCResults: [],
    isUpdatingProductLoP: false,
    requestedUpdateUPCLoP: "",
    updateUPCSLoP: [],
    updateResultsLoP: [],
    trackNameQuery: { title: "", genre: "", isrcs: "" },
    syncData: [],
    isLoadingSyncData: false,   
    tempSyncList: [],
    tabIndexSync: 0,
    isUpdatingProductLyricist: false,
    requestedUpdateUPCLyricist: "",
    updateUPCSLyricist: [],
    updateResultsLyricist: [],
    syncfilterSelected: { title: "", genre: "", isrcs: "" },
    tagsML: [],
    isLoadingMLTags: false,
    isrcVerified: "",
    isSavingVerified: false,
    tagMLToUpdate: null,
    tagMLisUpdating: false,
    selectedMLAsset: null,

}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_ML_ASSET_SELECTED: {
            return {
                ...state,
                selectedMLAsset: action.asset
            }
        } 
            
        case 'CLEAR_TAGS': {
            return {
                ...state,
                selectedMoods: [],
                selectedEnvironmental: [],
                selectedaudio_quality: [],
                selectedinstruments: [],
                selectedaudio_tags: [],
            }
        }
        case SET_FILTER_GENRE: {
            let filter = Object.assign({}, state.syncfilterSelected);
            filter.genre = action.data;
            return {
                ...state,
                syncfilterSelected : filter
            }
        } case SET_FILTER_ISRC: {
            let filterI = Object.assign({}, state.syncfilterSelected);
            filterI.isrcs = action.data;
            return {
                ...state,
                syncfilterSelected: filterI
            }
        }
        case SET_FILTER_TITLE: {
            let filterT = Object.assign({}, state.syncfilterSelected);
            filterT.title = action.data;
            return {
                ...state,
                syncfilterSelected: filterT
            }
        }
        case 'SET_TAG_MODEL': {
            return {
                ...state,
                selectedTagModel: action.data
            }
        }
        case SET_MOODS: {
            return {
                ...state,
                selectedMoods: action.data
            }
        }
        case 'SET_ENVIROMENTAL': {
            return {
                ...state,
                selectedEnvironmental: action.data
            }
        }
        case 'SET_AUDIO_QUALITY': {
            return {
                ...state,
                selectedaudio_quality: action.data
            }
        }
        case 'SET_INSTRUMENTS': {
            return {
                ...state,
                selectedinstruments: action.data
            }
        }
        case 'SET_AUDIO_TAGS': {
            return {
                ...state,
                selectedaudio_tags: action.data
            }
        }
        case REQUEST_AUTOCOMPLETE_TAGS: {
            switch (action.tagType) {
                case "mood":
                    return {
                        ...state,
                        isLoadingMoods: true

                    }
                case "instrument":
                    return {
                        ...state,
                        isLoadingInstruments: true

                    }
                case "audio":
                    return {
                        ...state,
                        isLoadingAudioTags: true

                    }
                case "audio_quality":
                    return {
                        ...state,
                        isloadingQuality: true

                    }
                case "environmental":
                    return {
                        ...state,
                        isLoadingEnvironmental: true

                    }                  

                default: return {
                    ...state                  

                }
            }
        }
        case RECEIVE_AUTOCOMPLETE_TAGS: {
            switch (action.tagType) {
                case "mood":
                    return {
                        ...state,
                        isLoadingMoods: false,
                        moods: action.data

                    }
                case "instrument":
                    return {
                        ...state,
                        isLoadingInstruments: false,
                        instruments: action.data

                    }
                case "audio":
                    return {
                        ...state,
                        isLoadingAudioTags: false,
                        audio_tags: action.data

                    }
                case "audio_quality":
                    return {
                        ...state,
                        isloadingQuality: false,
                        audio_quality: action.data
                    }
                case "environmental":
                    return {
                        ...state,
                        isLoadingEnvironmental: false,
                        environmental: action.data
                    }

                default: return {
                    ...state

                }
            }
        }


        case REQUEST_SAVE_TAGS: {
            return {
                ...state,
                isSavingTags: true
            }
        }
        case RECEIVE_SAVE_TAGS: {
            return {
                ...state,
                isSavingTags: false,
                assetTagsList: state.assetTagsList.map(t => {
                    if (t.isrc === action.data.isrc) {
                        return action.data;
                    }

                    return t;
                }),
                selectedTagModel: action.data

            }
        }

        case REQUEST_ASSET_TAGS_LIST: {
            return {
                ...state,
                isLoadingAssetTagsList: true
            }
        }
        case RECEIVE_ASSET_TAGS_LIST: {
            return {
                ...state,
                assetTagsList: action.data._tracks,
                currentPage_Tags: action.data.currentPage,
                maxPage_Tags: action.data.maxPage,
                maxRecords_Tags: action.data.maxRecords,
                isLoadingAssetTagsList: false

            }
        }
        case REQUEST_TERRITORY_CHANGE:
            return {
                ...state,
                requestedTerritoryUPC: action.upc,
                isSavingTerritory: true,
                requestedTerritoryType: action.territory
            }
        case REQUEST_TERRITORY_CHANGE_SUCCESS:
            return {
                ...state,
                requestedTerritoryUPC: "",
                isSavingTerritory: false,
                requestedTerritoryType: action.territory,
                territoryResults: state.territoryResults.concat(action.data),
                territoriesUPCS: state.territoriesUPCS.filter(upc => upc !== action.upc)
         
            }
        case SET_UPCS_TERRITORIES:
            return {
                ...state,
                territoriesUPCS: action.data,
                requestedTerritoryType: action.territory,
                territoryResults: []

            }
        case SET_CATALOG_CODES:
            return {
                ...state,
                catalogCodes: action.data,
                requestedCatalog: action.catalog,
                catalogResults: []

            }
        case SET_MASS_PRODUCT_CODES:            
            return {
                ...state,
                massProductChangeCodes: action.data,
                requestedMassProductChangeProperty: action._prop,
                requestedMassProductChangeValue: action._value,
                massProductChangeResults: []
            }
        case REQUEST_PUBLISH_PRODUCT:
            return {
                ...state,
                requestedPublishUPC: action.upc,
                isPublishingProduct: true
            }
        case REQUEST_PUBLISH_PRODUCT_SUCCESS:
            return {
                ...state,
                requestedPublishUPC: "",
                isPublishingProduct: false,
                publishResults: state.publishResults.concat(action.data),
                publishUPCS: state.publishUPCS.filter(upc => upc !== action.upc)

            }
        case SET_UPCS_PUBLISH:
            return {
                ...state,
                publishUPCS: action.data,
                publishResults: []

            }
        case REQUEST_CATALOG_CHANGE:
            return {
                ...state,
                requestedCatalogCode: action.upc,
                isSavingCatalog: true,
                requestedCatalog: action.catalog
            }
        case REQUEST_CATALOG_CHANGE_SUCCESS:
            return {
                ...state,
                requestedCatalogCode: "",
                isSavingCatalog: false,               
                catalogResults: state.catalogResults.concat(action.data),
                catalogCodes: state.catalogCodes.filter(code => code !== action.code),
                requestedCatalog: action.catalog

            }
        case REQUEST_MASS_PRODUCT_CHANGE:
            return {
                ...state,
                requestedMassProductCode: action.upc,
                isSavingMassProductChange: true,
                requestedMassProductChangeProperty: action._prop,
                requestedMassProductChangeValue: action._value
            }
        case REQUEST_MASS_PRODUCT_SUCCESS:
            return {
                ...state,
                requestedMassProductCode: "",
                isSavingMassProductChange: false,
                massProductChangeResults: state.massProductChangeResults.concat(action.data),
                massProductChangeCodes: state.massProductChangeCodes.filter(code => code !== action.code),
                requestedMassProductChangeProperty: action._prop,
                requestedMassProductChangeValue: action._value

            }
        case REQUEST_NAME_SHORTLIST:
            return {
                ...state,
                
            }
        case RECEIVE_NAME_SHORTLIST:
            return {
                ...state,
                forceUpdate: true,
                shortLists: state.shortLists[state.shortLists.map((e, i) => [i, e]).filter(e => e._id === action.shortlist)[0][0]] = action.data,
                shortListsReady: state.shortListsReady[state.shortListsReady.map((e, i) => [i, e]).filter(e => e._id === action.shortlist)[0][0]] = action.data

            }
        case REQUEST_SINGLE_PRODUCT_CHANGE:
            return {
                ...state,

            }
        case REQUEST_SINGLE_PRODUCT_CHANGE_SUCCESS:          
            return {
                ...state,
                upcData: state.upcData[state.upcData.map((e, i) => [i, e]).filter(e => e.upc === action.code)[0][0]] = action.data
            }
        case GET_RELEASE_DATA:
            return {
                ...state,
                selectedReleaseUPCS: action.upcs,
                releaseData: null,
                isLoadingReleaseList: true
            }
        case RELEASE_DATA_SUCCESS:
            return {
                ...state,
                releaseData: action.data,
                selectedReleaseUPCS: action.upcs,
                isLoadingReleaseList: false
            }
        case GET_UPC_DATA:
            return {
                ...state,
                selectedUPCS: action.upcs,
                upcData:null,
                isLoadingUPCList: true
            }
        case UPC_DATA_SUCCESS:
            return {
                ...state,
                upcData:action.data,
                selectedUPCS: action.upcs,
                isLoadingUPCList: false
        }
        case CLEAR_SHORTLIST:
            return{
                ...state,
                    tempShortList:[]
            }
        case RECEIVE_READY_SHORTLIST:
            return{
                ...state,
                selectedShortlist: null,
                forceUpdate: true,
                shortlistAnalysis: null,
                shortLists: [],
                shortlistDetail: null,
                shortListsReady: []
            }
        case RECEIVE_DELETE_SHORTLIST:
            return {
                ...state,
                selectedShortlist: null,
                forceUpdate: true,
                shortlistAnalysis: null,
                shortLists: [],
                shortlistDetail: null               
            }
        case SET_GENRES_SELECTED:
            return { ...state, genresSelect: action.filtered }
        case SET_CATALOG_SELECTED:
            return { ...state, select2: action.filtered }
        case SET_CATALOG_FILTER:
            return { ...state, filtered: action.filtered }
        case SET_SHORTLIST_ISRC: {
            return {
                ...state,
                shortListISRC: action.isReady ? state.shortListISRC : action.isrc,
                shortListISRCReady: action.isReady ? action.isrc : state.shortListISRC
            }
        }
        case SET_TAB: {
            return {
                ...state,
                tabIndex: action.tab
            }

        }
        case SET_TAB_SYNC: {
            return {
                ...state,
                tabIndexSync: action.tab
            }

        }
        case REQUEST_SHORTLIST_ANALYSIS: {
            return {
                ...state,
                isLoadingShortListAnalysis: true
            }

        }
        case RECEIVE_SHORTLIST_ANALYSIS: {
            return {
                ...state,
                isLoadingShortListAnalysis: false,
                shortlistAnalysis: action.isReady ? state.shortlistAnalysis:action.data,
                shortlistAnalysisReady: action.isReady ? action.data : state.shortlistAnalysisReady
            }
        }

        case RECEIVE_SHORTLIST_ANALYSIS_INTERNAL: {
            console.info( action.id)
            return {
                ...state,
                isLoadingShortListAnalysis: false,
                shortlistAnalysis: action.isReady ? state.shortlistAnalysis : state.shortLists.filter(t => t.shortlistId === action.id)[0],
                
            }
        }
        case REQUEST_AUTOCOMPLETE_SHORTLIST: {
            if (action.isReady) {
                return {
                    ...state,
                    isLoadingReadyShortLists: true
                }
            } else {
                return {
                    ...state,
                    isLoadingShortlists: true
                }
            }
           
        }
        case RECEIVE_AUTOCOMPLETE_SHORTLIST: {
            if (action.isReady) {
                return {
                    ...state,
                    isLoadingReadyShortLists: false,                    
                    shortListsReady:  action.payload,
                    forceUpdate: false,
                    firstLoad:true
                }
            } else {
                return {
                    ...state,
                    isLoadingShortlists: false,
                    shortLists:action.payload,                   
                    forceUpdate: false,
                    firstLoad:true

                }
            }
           
        }
        case REQUEST_SHORTLIST_DRAFT: {
            return {
                ...state,
                requestedShortList: action.isReady ? state.requestedShortList : state.selectedShortlist,
                requestedShortListReady: action.isReady ? state.selectedShortlistReady : state.requestedShortListReady
            }

        }
        case RECEIVE_SHORTLIST_DRAFT: {
            return {
                ...state,
                requestedShortList: action.isReady ? state.requestedShortList : state.selectedShortlist,
                shortlistDetail: action.isReady ? state.shortlistDetail : action.data.shortlist,
                requestedShortListReady: action.isReady ? state.selectedShortlistReady : state.requestedShortListReady,
                shortlistDetailReady: action.isReady ? action.data.shortlist : state.shortlistDetailReady
               
            }
        }
        case MODIFY_SHORTLIST: {
            return {
                ...state,
                tempShortList: state.shortlistDetail.assets,
                shortListName: state.shortlistDetail.name,
                tabIndex:1
            }
        }

        case SET_SHORTLIST: {
            return {
                ...state,
                selectedShortlist: action.isReady ? state.selectedShortlist: action.shortlist,
                selectedShortlistReady: action.isReady ? action.shortlist : state.selectedShortlistReady
            }
        }

        case SET_SHORTLIST_BY_STATE: {
            switch (action._type) {
                case "correction":
                    return {
                        ...state,
                        selectedShortlistCorrection:  action.shortlist                     
                    }
                default:
                    return {
                        ...state
                    }
            }
           
        }
        case REQUEST_CREATE_SHORTLIST: {
            return {
                ...state,
                isSavingAssetsToShortList: true
            }
        }
        case RECEIVE_CREATE_SHORTLIST: {
            return {
                ...state,
                isSavingAssetsToShortList: false,                      
                shortlistDetail: action.data,
                tempShortList: action.data.assets,
                forceUpdate: true
            }
        }
        case SET_SHORTLIST_NAME: {
            return {
                ...state,
                shortListName: action.name
            }
        }

        case SELECT_TRACK: {
            return {
                ...state,
                tempShortList: state.tempShortList.filter(t => t.isrc === action._id).length > 0 ? state.tempShortList.filter(t => t.isrc !== action._id) : state.tempShortList.concat(state.summary.filter(t => t.isrc === action._id)[0])
            }
        }

        case SELECT_SYNC_TRACK: {
            return {
                ...state,
                tempSyncList: state.tempSyncList.filter(t => t.isrc === action._id).length > 0 ? state.tempSyncList.filter(t => t.isrc !== action._id) : state.tempSyncList.concat(state.syncData.filter(t => t.isrc === action._id)[0])
            }
        }
        case SELECT_PRODUCT_FOR_UPDATE: {
            return {
                ...state,
                selectedProductForUpdate: action._id
            }
        }

        case SORT_TEMP_SHORTLIST: {
            return {
                ...state,
                tempShortList: action.tracks
                //shortlistDetail: {
                //    name: state.shortlistDetail.name,
                //    user: state.shortlistDetail.user,
                //    createDate: state.shortlistDetail.createDate,
                //    _id: state.shortlistDetail._id,
                //    notes: state.shortlistDetail.notes,
                //    assets: action.tracks
                //}
            }
        }
        case SET_AUDIOURL:
            return { ...state, audioURL: action.url }

        case GET_ML_TAGS:
            return { ...state, isLoadingMLTags: true, tagsML: [] }

        case GET_ML_TAGS_SUCCESS:
            return {
                ...state, isLoadingMLTags: false, tagsML: action.payload
            }

        case GET_DATA_START:
            return { ...state, isLoading: true, login_error: '' };
        case GET_DATA_SUCCESS:
            return {
                ...state,
                isLogin: true,
                isLoading: false,
                summary: action.payload,
                catalogues: [...new Set(action.payload.map(x => x.catalog))],
                genres: [...new Set(action.payload.map(x => x.genre))],
            };
        case GET_QUARTER_DATA_START:
            return {
                ...state,
                isLoading: true,
                selectedQuarter: action.quarter,
                quarterList : null
            };
        case GET_QUARTER_DATA_SUCCESS:
            return {
                ...state,
                isLoading: false,
                selectedQuarter: action.quarter,
                quarterList: action.payload
            };
        case GET_QUARTER_CHART_START:
            return { ...state, isLoading: true };
        case GET_QUARTER_CHART_SUCCESS:
            return {
                ...state,
                isLoading: false,
                quarterChart: action.payload
            };
        case GET_QUARTER_DSP_CHART_START:
            return {
                ...state,
                dspQuarter: action.quarter,
                dspQuarterChart: null,
                isLoading: true
            };
        case GET_QUARTER_DSP_CHART_SUCCESS:
            return {
                ...state,
                dspQuarterChart: action.payload,
                isLoading: false,
                dspQuarter: action.quarter
                
            }
        case GET_QUARTER_TERRITORY_CHART_START:
            return {
                ...state,
                territoryQuarter: action.quarter,
                isLoading: true,
                territoryQuarterChart: null
            };
        case GET_QUARTER_TERRITORY_CHART_SUCCESS:
            return {
                ...state,
                territoryQuarterChart: action.payload,
                isLoading: false,
                territoryQuarter: action.quarter

            };
        case GET_ASSET_PROFILE_START:
            return {
                ...state,
                requestedISRC: action.isrc,
                assetData: null,
                isLoadingAsset: true
            };
        case GET_ASSET_PROFILE_SUCCESS:
            return{
                ...state,
                requestedISRC:action.isrc,
                isLoadingAsset: false,
                assetData: action.payload
            }
        case GET_TOPS_QUARTER_START:
            return {
                ...state,
                topsQuarter: action.quarter,
                topsQuarterData: null
            }
        case GET_TOPS_QUARTER_SUCCESS:
            return {
                ...state,
                topsQuarter: action.quarter,
                topsQuarterData: action.payload
            }
        case GET_QUARTER_TERRITORY_CHART_DOWNLOADS_START:
            return {
                ...state,
                territoryDownloads: null,
                territoryDownloadsQuarter: action.quarter
            }
        case GET_QUARTER_TERRITORY_CHART_DOWNLOADS_SUCESS:
            return {
                ...state,
                territoryDownloads: action.payload,
                territoryDownloadsQuarter: action.quarter
            }
        case GET_QUARTER_TERRITORY_CHART_STREAMS_START:
            return {
                ...state,
                territoryStreams: null,
                territoryStreamsQuarter: action.quarter
            }
        case GET_QUARTER_TERRITORY_CHART_STREAMS_SUCESS:
            return {
                ...state,
                territoryStreams: action.payload,
                territoryStreamsQuarter: action.quarter
            }
        case GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_START:
            return {
                ...state,
                territoryStreamsIsrc: action.isrc,
                territoryStreamsIsrcData: null
            }
        case GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_SUCESS:
            return {
                ...state,
                territoryStreamsIsrc: action.isrc,
                territoryStreamsIsrcData: action.payload
            }
        case GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_START:
            return {
                ...state,
                territoryDownloadsIsrc: action.isrc,
                territoryDownloadsIsrcData: null
            }
        case GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_SUCESS:
            return {
                ...state,
                territoryDownloadsIsrc: action.isrc,
                territoryDownloadsIsrcData: action.payload
            }
        case GET_ISRC_DSP_CHART_START:
            return {
                ...state,
                dspISRC: action.isrc,
                dspISRCData: null
            };
        case GET_ISRC_DSP_CHART_SUCESS:
            return {
                ...state,
                dspISRCData: action.payload,              
                dspISRC: action.isrc

            }
        case GET_ISRC_CHART_DATE_START:
            switch (action.chartType) {
                case "activity":
                    return {
                        ...state,
                        chartIsrc : action.isrc,
                        chartIsrcType: action.chartType,
                        chartIsrcStartMonth: action.startMonth,
                        chartIsrcStartYear: action.startYear,
                        chartIsrcEndYear: action.endYear,
                        chartIsrcEndMonth: action.endMonth,
                        chartIsrcActivity: null,
                    }
                default:
            }
            break;
        case GET_ISRC_CHART_DATE_SUCESS:
            switch (action.chartType) {
                case "activity":
                    return {
                        ...state,
                        chartIsrc: action.isrc,
                        chartIsrcType: action.chartType,
                        chartIsrcStartMonth: action.startMonth,
                        chartIsrcStartYear: action.startYear,
                        chartIsrcEndYear: action.endYear,
                        chartIsrcEndMonth: action.endMonth,
                        chartIsrcActivity: action.payload,
                    }
                default:
            }
            break;
        case GET_QUARTER_ACTIVITY_CHART_START:
            return {
                ...state,
                activityChart: null,
                activityQuarter : action.quarter
            };
        case GET_QUARTER_ACTIVITY_CHART_SUCCESS:
            return {
                ...state,
                activityChart: action.payload,
                activityQuarter: action.quarter
            }
        case GET_IMPERSONATION_LIST_START:
            return {
                ...state,
                 recipientListLoading: true,
               
            }
        case GET_IMPERSONATION_LIST_SUCCESS:
            return {
                ...state,
                recipientList: action.payload,
                 recipientListLoading: false,
               
            }
        case SET_IMPERSONATION_LIST_START:
            return {
                ...state,
                recipientID: action.id,
                recipientListLoading: true,
                recipientList: null,
                recipientSaving:true
            }
        case SET_IMPERSONATION_LIST_SUCCESS:
            return {
                ...state,
                recipientID: action.id,
                recipientList: action.payload,
                recipientListLoading: false,
                recipientSaving: false
            }
        case REQUEST_UPDATE_PRODUCT:
            return {
                ...state,
                requestedUpdateUPC: action.upc,
                isUpdatingProduct: true
            }
        case REQUEST_UPDATE_PRODUCT_SUCCESS:
            return {
                ...state,
                requestedUpdateUPC: "",
                isUpdatingProduct: false,
                updateResults: state.updateResults.concat(action.data),
                updateUPCS: state.updateUPCS.filter(upc => upc !== action.upc)
            }
        case SET_UPCS_UPDATE:
            return {
                ...state,
                updateUPCS: action.data,
                updateResults: []

            }
        case SET_ISRCS_UPDATE:
            return {
                ...state,
                updateISRCS: action.data,
                updateISRCResults: []

            }
        case REQUEST_UPDATE_ASSET:
            return {
                ...state,
                requestedUpdateISRC: action.isrc,
                isUpdatingAsset: true
            }
        case REQUEST_UPDATE_ASSET_SUCCESS:
            return {
                ...state,
                requestedUpdateISRC: "",
                isUpdatingAsset: false,
                updateISRCResults: state.updateISRCResults.concat(action.data),
                updateISRCS: state.updateISRCS.filter(upc => upc !== action.isrc)
            }
        case REQUEST_UPDATE_LOP:
            return {
                ...state,
                requestedUpdateUPCLoP: action.upc,
                isUpdatingProductLoP: true
            }
        case REQUEST_UPDATE_LOP_SUCCESS:
            return {
                ...state,
                requestedUpdateUPCLoP: "",
                isUpdatingProductLoP: false,
                updateResultsLoP: state.updateResultsLoP.concat(action.data),
                updateUPCSLoP: state.updateUPCSLoP.filter(upc => upc !== action.upc)
            }
        case SET_UPCS_LOP_UPDATE:
            return {
                ...state,
                updateUPCSLoP: action.data,
                updateResultsLoP: []

            }
        case GET_SYNC_DATA:
            return {
                ...state,
                syncData: [],
                isLoadingSyncData: true,
                trackNameQuery: action.nameQuery
            }
        case GET_SYNC_DATA_SUCCESS:
            return {
                ...state,
                syncData: action.data,
                isLoadingSyncData: false,
                trackNameQuery: action.nameQuery,
                syncfilterSelected: { title: "", genre: "", isrcs: "" },
            }
        case REQUEST_UPDATE_LYRICIST:
            return {
                ...state,
                requestedUpdateUPCLyricist: action.upc,
                isUpdatingProductLyricist: true
            }
        case REQUEST_UPDATE_LYRICIST_SUCCESS:
            return {
                ...state,
                requestedUpdateUPCLyricist: "",
                isUpdatingProductLyricist: false,
                updateResultsLyricist: state.updateResultsLyricist.concat(action.data),
                updateUPCSLyricist: state.updateUPCSLyricist.filter(upc => upc !== action.upc)
            }
        case SET_UPCS_LYRICIST_UPDATE:
            return {
                ...state,
                updateUPCSLyricist: action.data,
                updateResultsLyricist: []

            }
        default: return state;

    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/dataReducer.js